<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i4rHS/tc-custom/9781683504368.jpg?1704761694401" alt="This image is the cover for the book Proven Player"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Proven Player
      </h1>
      <p class="bookDescription body article font2">
        <i>Proven Player</i> serves as an instructional manual to be used by coaches and athletes to strengthen the development of their character as it pertains to sports and life. In this life there seems to always be a need to prove one’s self and with that thought a person needs to know what it takes to demonstrate the accurate character traits that makes one a “Proven Player.” If a person is to know how to handle certain situations on the plateau of their given sport or within this life, he or she will need a plan to insure that the situations on the playing field and in life are responded to in a proper manner that brings a greater passion for life and those around them that are affected by their responses.<p><i>Proven Player</i> is that plan!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Powell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42c00134